<template>
    <div v-if="selfServiceDetails.tag ==='end'">
        <b-alert show>
            <p>{{$t('pages.selfservice.passwordReset.successMessage')}}</p>
        </b-alert>
    </div>
    <div v-else-if="typeof selfServiceDetails.error !== 'string'">
        <ValidationObserver ref="observer" slim>
            <b-form @keyup.enter="save" @submit.prevent>
                <ValidationProvider :rules="'required'" v-slot="{ errors }" name="code">
                    <div class="mb-3">
                        <div class="form-label-text form-label-group mb-0" ref="floatingLabelGroup">
                            <p class="radioStyle">{{$t("pages.selfservice.headers.reset.otptextmsg1")}}<b> XXXXXX{{selfServiceDetails.requirements.telephoneNumber}}</b></p>
                            <p class="radioStyle">{{$t(`pages.selfservice.headers.reset.otptextmsg2`)}}</p>
                            <input :type="inputType" :class="{'form-control custom-text ': true, 'error': errors.length > 0}" :placeholder="$t('common.form.OtpTextbox')" data-vv-validate-on="input|keyup|submit" v-model="code">
                        </div>
                        <div class="fr-validation-requirements text-left">
                            <span v-for="(error, index) in errors" :key="index" class="text-danger">{{ error }}</span>
                        </div>
                    </div>
                </ValidationProvider>
                <div id="otp-div" class="pull-right"  style="text-align:right;">
                    <fr-loading-button type="button" variant="primary" class="w-50 d-inline-block buttondisp" style="display:inline-block!important;"
                                :label="$t('common.form.resendotp')"
                                :large="true"
                                :loading="resendloading"
                                @click="resend"></fr-loading-button>
                    <fr-loading-button type="button" variant="primary" class="w-50 d-inline-block buttondisp" style="display:inline-block!important;"
                                :label="$t('common.form.verifyotp')"
                                :loading="loading"
                                :large="true"
                                @click="save"></fr-loading-button>
                </div>
            </b-form>
        </ValidationObserver>
    </div>
    <div v-else>
        <b-alert variant="danger" show>
            <b>{{$t('pages.selfservice.passwordReset.unableReset')}}</b>
            <p>{{selfServiceDetails.error}}</p>
        </b-alert>
        <div class="mt-2">
            <a href="#/passwordreset?otp=true" v-on:click="reloadPage">{{$t("pages.selfservice.passwordReset.tryAgain")}}</a>
        </div>
    </div>
</template>

<script>
// import { has, find, map } from 'lodash';
// import PolicyPasswordInput from '@/components/utils/PolicyPasswordInput';
import LoadingButton from '@/components/utils/LoadingButton';

/**
* @description Selfservice stage for password reset, handles the final result of password reset, either displaying an error or that the reset has been complete
*
**/
export default {
    name: 'Verify-SMSOTP',
    props: {
        selfServiceDetails: { required: true },
        showconf: String,
        showconf1: Boolean,
        show: String
    },
    components: {
        'fr-loading-button': LoadingButton
    },
    data () {
        return {
            password: '',
            userPassword: '',
            inputType: 'password',
            inputConfType: 'password',
            defaultPolicyFailures: null,
            code: '',
            loading: false,
            resendloading: false
        };
    },
    methods: {
        created () {
        },
        getData () {
            return {
                code: this.code
            };
        },
        getResendData () {
            return {
                code: this.code,
                resend: 'true'
            };
        },
        save () {
            this.isValid().then((valid) => {
                if (valid) {
                    this.loading = true;
                    this.$emit('advanceStage', this.getData());
                }
            });
        },
        resend () {
            this.resendloading = true;
            this.$emit('advanceStage', this.getResendData());
            this.resendloading = false;
        },
        reloadPage (event) {
            event.preventDefault();
            window.location.reload();
        },
        isValid () {
            /* istanbul ignore next */
            return this.$refs.observer.validate();
        }
    }
};
</script>

<style scoped>
@import '../../../scss/pearson-common.css';
</style>
